/**
 * Copyright © Veeam Software Group GmbH.
 */

import { useContext } from 'react';

import { ManagedBackupAgentsContext } from '../contexts/ManagedBackupAgentsContext';

export const useManagedBackupAgentsStore = () => useContext(ManagedBackupAgentsContext);
